import { render, staticRenderFns } from "./ReportOverdueLoan.vue?vue&type=template&id=1541faff"
import script from "./ReportOverdueLoan.vue?vue&type=script&lang=js"
export * from "./ReportOverdueLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports